import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { WhiteSpaceValidator } from 'src/app/validators/white-space.validator';
import { AddonService, ItemService, OptionalService, ItemOutputDto, AddonOutputDto, OptionalGetOneDto, OptionalInputDto, OptionalUpdateDto, StoreResponseDto } from 'src/generated_client';

@Component({
  selector: 'app-add-optional',
  templateUrl: './add-optional.component.html',
  styleUrls: ['./add-optional.component.css']
})

export class AddOptionalComponent implements OnInit {

  id: any;
  isEdit: boolean = false;
  title: string = "";

  addOptionalForm: FormGroup = this.fb.group({
    cdOptional: [],
    name: ['', Validators.compose([Validators.required,Validators.pattern('[A-Z][a-z ]*'), WhiteSpaceValidator.cannotContainSpace])],
    // minQuantity: [''],
    maxQuantity: ['', Validators.required],
  })

  products: Item[] = [];
  addons: Addon[] = [];

  getOne: OptionalGetOneDto = {} as OptionalGetOneDto;
  optionalUpdate: OptionalUpdateDto = {} as OptionalGetOneDto;
  optionalInput: OptionalInputDto = {} as OptionalInputDto;
  storeResponse: StoreResponseDto = {} as StoreResponseDto;

  constructor(
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private optionalService: OptionalService,
    private addonService: AddonService,
    private itemService: ItemService,
    private authService: AuthService,
    private router: Router,
    private snackBar: SnackBarService
  ) { }

  ngOnInit(): void {
    this.storeResponse = this.authService.currentUserStore();
    this.id = this.activatedRoute.snapshot.paramMap.get("id")
    if (this.id != null) {
      this.isEdit = true;
      this.optionalService.apiOptionalGetOneGet(this.id).subscribe(x => {
        this.SetControlData(x);
        this.getOne = x;
        this.itemService.apiItemGetAllGet(this.storeResponse.cdStore).subscribe(x => {
          this.products = x;
          this.products.forEach(x => {
            x.checked = this.getOne.optionalItemsOutputDtos?.includes(Number(x.cdItem));
          });
        });
        this.addonService.apiAddonGetAllByStoreGet(this.storeResponse.cdStore).subscribe(x => {
          this.addons = x;
          this.addons.forEach(x => {
            x.checked = this.getOne.optionalAddonOutputDtos?.includes(Number(x.cdAddon));
          });
        });
      });
    }
    else {
      this.itemService.apiItemGetAllGet(this.storeResponse.cdStore).subscribe(x => {
        this.products = x;
      });
      this.addonService.apiAddonGetAllByStoreGet(this.storeResponse.cdStore).subscribe(x => {
        this.addons = x;
      });
    }
    this.changeTitle();
  }

  saveChanges(form: any) {
    if (this.isEdit) {
      this.SetUpdate(form);
      this.optionalService.apiOptionalPutPut(this.optionalUpdate).subscribe(response => {
        this.router.navigate(['optionals-management']);
        this.snackBar.openSnackBar('Los cambios se guardaron correctamente','Aceptar')
      },
        err => {
          console.log(err)
          this.snackBar.openSnackBar(err.error.error, 'Aceptar')
        }
      )
    } else {
      this.SetInput(form);
      this.optionalService.apiOptionalPostPost(this.optionalInput).subscribe(response => {
        this.router.navigate(['optionals-management']);
        this.snackBar.openSnackBar('Los cambios se guardaron correctamente','Aceptar')
      },
        err => {
          this.snackBar.openSnackBar(err.error.error, 'Aceptar')
        }
      )
    }
  }

  private changeTitle() {
    if (this.isEdit) {
      this.title = "EDITAR OPCIONAL";
    } else {
      this.title = "AGREGAR NUEVO OPCIONAL";
    }
  }

  private SetControlData(x: OptionalGetOneDto) {
    this.addOptionalForm.controls['cdOptional'].setValue(Number(this.id));
    this.addOptionalForm.controls['name'].setValue(x.dsName);
    this.addOptionalForm.controls['maxQuantity'].setValue(x.nmMaximum);
  }

  private SetInput(form: any) {
    this.optionalInput = {
      cdStore: Number(this.storeResponse.cdStore),
      dsName: form.name,
      nmMaximum: Number(form.maxQuantity),
      cdsAddon: this.addons.filter(x => x.checked).map(x => Number(x.cdAddon)),
      cdsItems: this.products.filter(x => x.checked).map(x => Number(x.cdItem))
    };
  }

  private SetUpdate(form: any) {
    this.optionalUpdate = {
      cdOptional: form.cdOptional,
      cdStore: Number(this.storeResponse.cdStore),
      dsName: form.name,
      nmMaximum: Number(form.maxQuantity),
      cdsAddon: this.addons.filter(x => x.checked).map(x => Number(x.cdAddon)),
      cdsItems: this.products.filter(x => x.checked).map(x => Number(x.cdItem))
    };

    console.log(Number(form.maxQuantity));
  }
}

interface Item extends ItemOutputDto {
  checked?: boolean
}

interface Addon extends AddonOutputDto {
  checked?: boolean
}
